import React from 'react';
import { useState, Helmet} from "react";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Fetching from './Fetching';

document.title = "Bitcoin Calculator";

ReactDOM.render(
  <React.StrictMode>
    <Fetching/>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
